
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { notificacionesXBodegas } from "../../../services";










export const useNotificacionXBodega = (id) => {

    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const notificacionXBodegaQuery = useQuery({
        queryKey: ['notificacion-xbodega', { page, termino, id }], 
        queryFn: () => notificacionesXBodegas({ page, termino, id }),
    });

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        notificacionXBodegaQuery,
    }
}





// export const useProductoXID = (id) => {

//     const productoXIDQuery = useQuery({
//         queryKey: ['producto-id', id], 
//         queryFn: () => startProductoXID(id),
//     });

//     return {
//         productoXIDQuery
//     }
// }





// export const useProductosQuery = () => {
    
//     const [page, setPage] = useState(0);
//     const [termino, setTermino] = useState('');

//     const productosListQuery = useQuery({
//         queryKey: ['productos-list', { page, termino }], 
//         queryFn: () => startListadoProductos({ page, termino }),
//     });
    

//     const chagePage = (num) => {
//         setPage(num - 1);
//     }

//     const chageTermino = (valor) => {
//         setPage(0);
//         setTermino(valor)
//     }

    
//     return {
//         // Estados
//         page,
//         termino,
//         // Metodos
//         chagePage,
//         chageTermino,
//         productosListQuery,
//     }
// }
